import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import { twMerge as mergeClassNames } from 'tailwind-merge'

import { Tooltip } from '@/components/ui/Tooltip'

/**
 *
 * CheckBox
 *
 */
const CheckBox = forwardRef(
  (
    { className, disabled, disabledDescription = null, label, name, onChange, value, ...rest },
    ref,
  ) => (
    <Tooltip
      content={
        <div className="text-white-dark rounded-lg border border-blue-800 bg-blue-800 p-1.5 text-sm normal-case shadow-md">
          {disabledDescription}
        </div>
      }
      display={disabled && disabledDescription}
    >
      <div
        className={mergeClassNames('group flex items-center space-x-2', className)}
        data-disabled={disabled}
      >
        <input
          disabled={disabled}
          id={name}
          name={name}
          type="checkbox"
          className="appearance-none rounded-sm border-2 border-blue-800 checked:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-50"
          checked={value}
          onChange={onChange}
          ref={ref}
          {...rest}
        />

        {label && (
          <label
            htmlFor={name}
            className="text-sm font-medium text-gray-700 group-data-[disabled=true]:cursor-not-allowed group-data-[disabled=true]:text-gray-400"
          >
            {label}
          </label>
        )}
      </div>
    </Tooltip>
  ),
)

CheckBox.defaultProps = {
  className: null,
  disabled: false,
  label: null,
}

CheckBox.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledDescription: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
}

export default CheckBox
